<app-nhr-loader [show]="$loading | async" />
<div class="next-horse-race">
  @if (titleRace) {
    <div class="nhr-header">
      <span class="title-1"> {{ "Next Horse Race" | translate }} </span>
      <a
        [routerLink]="[
          '/app/main',
          {
            outlets: {
              navigation: ['event', titleRace?.eventId],
              content: ['event-markets', titleRace?.eventId, 'market', titleRace?.id],
            },
          },
        ]"
        >{{ titleRace?.startTime | date: "HH:mm" }}
        {{ titleRace?.raceVenue }} ({{ titleRace?.countryCode }})</a
      >
      <span class="title-2">{{ titleRace?.name }}</span>
    </div>
  }

  @if (nextRaces.length > 0) {
    <div class="nhr-content">
      <span>
        <b>{{ "Coming up" | translate }}: </b>
        @for (each of nextRaces; track each?.id; let i = $index) {
          <a
            [routerLink]="[
              '/app/main',
              {
                outlets: {
                  navigation: ['event', each?.eventId],
                  content: ['event-markets', each?.eventId, 'market', each?.id],
                },
              },
            ]"
            >{{ each?.startTime | date: "HH:mm" }} {{ each?.raceVenue }} ({{
              each?.countryCode
            }})</a
          >
          {{ i !== nextRaces.length - 1 ? "|" : "" }}
        }
      </span>
    </div>
  }

  @if (!($loading | async) && !titleRace && nextRaces.length === 0) {
    <app-alert
      [config]="{
        title: 'No Upcoming Horse Races.',
        subtitle: 'There are no upcoming horse races.',
        type: 'info',
      }"
    />
  }
</div>
